import $ from "jquery";
export var SocialMedia = function () {
    // Fonction pour traiter un formset
    var processFormset = function (formset) {
        var checkbox = formset.find('.checkboxinput');
        checkbox.hide();
        var deleteField = formset.find('input[name*="DELETE"]');
        var deleteLabel = formset.find('label[for*="DELETE"]');
        deleteLabel.hide();
        var langCode = document.getElementById("language-code").value;
        var deleteButtonText = langCode === "fr" ? "Supprimer" : "Delete";
        var deleteButton = $("<button type=\"button\" class=\"btn btn-danger mb-2\">".concat(deleteButtonText, "</button>"));
        deleteButton.click(function () {
            checkbox.prop("checked", true);
            deleteField.val("on");
            formset.hide();
        });
        formset.append(deleteButton);
    };
    var initExistingFormsets = function () {
        $('#formsetsocialmedia span[id$="_social"]').each(function () {
            var formset = $(this);
            processFormset(formset);
        });
    };
    $(document).ready(function () {
        initExistingFormsets();
        $("#add_more_social_media").click(function () {
            var form_idx = $("#id_formsetsocialmedia-TOTAL_FORMS").val();
            var newFormHtml = $("#empty_media_social_form")
                .html()
                .replace(/__prefix__/g, form_idx);
            var newFormset = $(newFormHtml);
            processFormset(newFormset);
            $("#formsetsocialmedia").append(newFormset);
            $("#id_formsetsocialmedia-TOTAL_FORMS").val(parseInt(form_idx) + 1);
        });
    });
};
